// AUTO-GENERATED offline cold-start fallback for the Warehouse Receiving scanner.
// Source: Item master Data_08.02.26.xlsx (DataMatrix + 1D barcodes decoded from label photos).
// The LIVE MasterDataLocal sap-items / OBCD sync ALWAYS takes precedence over this seed.

export interface ItemMasterSeedRow {
  itemNo: string;
  itemDescription: string;
  itemGroup: string;
  pic: string;
  barcode: string;
  gtin: string;
}

export const ITEM_MASTER_SEED: ItemMasterSeedRow[] = [
  {
    "itemNo": "A10001",
    "itemDescription": "Actilift Cream",
    "itemGroup": "Skintech Retail",
    "pic": "",
    "barcode": "",
    "gtin": ""
  },
  {
    "itemNo": "A10096",
    "itemDescription": "Ammoway (Sodium Phenylacetate and Sodium Benzoate)",
    "itemGroup": "SPSB",
    "pic": "",
    "barcode": "",
    "gtin": "00368475903012"
  },
  {
    "itemNo": "A10226",
    "itemDescription": "ARINA 10MG A/E PACK 30 OD TABLETS_FOC",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870086005",
    "gtin": "06251870086005"
  },
  {
    "itemNo": "A10225",
    "itemDescription": "ARINA 10MG A/E PACK 30 OD TABLETS_PVT",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870086005",
    "gtin": "06251870086005"
  },
  {
    "itemNo": "A10230",
    "itemDescription": "ARINA 15MG A/E PACK 30 OD TABLETS_FOC",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870086012",
    "gtin": "06251870086012"
  },
  {
    "itemNo": "A10229",
    "itemDescription": "ARINA 15MG A/E PACK 30 OD TABLETS_PVT",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870086012",
    "gtin": "06251870086012"
  },
  {
    "itemNo": "A10129",
    "itemDescription": "Arox UD Eye Drops_FOC",
    "itemGroup": "Jamjoom-FOC",
    "pic": "",
    "barcode": "",
    "gtin": "06285128025492"
  },
  {
    "itemNo": "A10128",
    "itemDescription": "Arox UD Eye Drops_PVT",
    "itemGroup": "Jamjoom-Pvt",
    "pic": "",
    "barcode": "",
    "gtin": "06285128025492"
  },
  {
    "itemNo": "A10066",
    "itemDescription": "Artiz 10mg FC Tab 10's",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6281102235611",
    "gtin": "06285147000074"
  },
  {
    "itemNo": "A10051",
    "itemDescription": "Asonor Nasal Spray 30ml",
    "itemGroup": "Asonor",
    "pic": "",
    "barcode": "5703562001007",
    "gtin": "05703562001007"
  },
  {
    "itemNo": "A10002",
    "itemDescription": "Atrofillin Cream",
    "itemGroup": "Skintech Retail",
    "pic": "",
    "barcode": "",
    "gtin": ""
  },
  {
    "itemNo": "A10052",
    "itemDescription": "Cachet -ALFAZYME FORTE 30's",
    "itemGroup": "Cachet",
    "pic": "",
    "barcode": "8906031059067",
    "gtin": "08906031059067"
  },
  {
    "itemNo": "A10105",
    "itemDescription": "Cachet-XZYME TABLETS",
    "itemGroup": "Cachet",
    "pic": "",
    "barcode": "",
    "gtin": "06285128025492"
  },
  {
    "itemNo": "A10053",
    "itemDescription": "Contec BP machine 08C",
    "itemGroup": "Contec",
    "pic": "",
    "barcode": "6945040100331",
    "gtin": "06945040100331"
  },
  {
    "itemNo": "A10054",
    "itemDescription": "Contec BP machine 08E",
    "itemGroup": "Contec",
    "pic": "",
    "barcode": "6945040106258",
    "gtin": "06945040106258"
  },
  {
    "itemNo": "A10055",
    "itemDescription": "Contec Compressor Nebuliser J01",
    "itemGroup": "Contec",
    "pic": "",
    "barcode": "",
    "gtin": ""
  },
  {
    "itemNo": "A10056",
    "itemDescription": "Contec Mesh Nebuliser M01",
    "itemGroup": "Contec",
    "pic": "",
    "barcode": "",
    "gtin": ""
  },
  {
    "itemNo": "A10057",
    "itemDescription": "Contec Mesh Nebuliser M01L",
    "itemGroup": "Contec",
    "pic": "",
    "barcode": "",
    "gtin": ""
  },
  {
    "itemNo": "A10067",
    "itemDescription": "Derma T Solution 1%",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6285147000876",
    "gtin": "06285147000876"
  },
  {
    "itemNo": "A10355",
    "itemDescription": "Diabetica General Organizer-A_FOC",
    "itemGroup": "Medysinal FZCO",
    "pic": "",
    "barcode": "5100002015011",
    "gtin": "05100002015011"
  },
  {
    "itemNo": "A10354",
    "itemDescription": "Diabetica General Organizer-A_PVT",
    "itemGroup": "Medysinal FZCO",
    "pic": "",
    "barcode": "5100002015011",
    "gtin": "05100002015011"
  },
  {
    "itemNo": "A10353",
    "itemDescription": "Diabetica Wallet Organizer-A_FOC",
    "itemGroup": "Medysinal FZCO",
    "pic": "",
    "barcode": "5100002008235",
    "gtin": "05100002008235"
  },
  {
    "itemNo": "A10352",
    "itemDescription": "Diabetica Wallet Organizer-A_PVT",
    "itemGroup": "Medysinal FZCO",
    "pic": "",
    "barcode": "5100002008235",
    "gtin": "05100002008235"
  },
  {
    "itemNo": "A10079",
    "itemDescription": "Divido 75mg.D Relase Caps 20s",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6281102230593",
    "gtin": "06281102230593"
  },
  {
    "itemNo": "A10073",
    "itemDescription": "FEXODINE TABLETS 120MG 14'S",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6285147001194",
    "gtin": "06285147001194"
  },
  {
    "itemNo": "A10075",
    "itemDescription": "IVARIN 10MG TABLETS 30'S",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147001798"
  },
  {
    "itemNo": "A10076",
    "itemDescription": "IVARIN 20MG TABLETS 30'S",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147001804"
  },
  {
    "itemNo": "A10043",
    "itemDescription": "Jamjoom Fusibact B Cream_PVT",
    "itemGroup": "Jamjoom-Pvt",
    "pic": "",
    "barcode": "",
    "gtin": "06285128022958"
  },
  {
    "itemNo": "A10040",
    "itemDescription": "Jamjoom Fusibact Cream_PVT",
    "itemGroup": "Jamjoom-Pvt",
    "pic": "",
    "barcode": "6281269105321",
    "gtin": "06281269105321"
  },
  {
    "itemNo": "A10038",
    "itemDescription": "Jamjoom Fusibact Ointment_PVT",
    "itemGroup": "Jamjoom-Pvt",
    "pic": "",
    "barcode": "",
    "gtin": ""
  },
  {
    "itemNo": "A10047",
    "itemDescription": "Jamjoom Lamifen Cream_PVT",
    "itemGroup": "Jamjoom-Pvt",
    "pic": "",
    "barcode": "",
    "gtin": "06285128023429"
  },
  {
    "itemNo": "A10125",
    "itemDescription": "JAVINO CR",
    "itemGroup": "Jamjoom-Pvt",
    "pic": "",
    "barcode": "",
    "gtin": "06285128002707"
  },
  {
    "itemNo": "A10080",
    "itemDescription": "Lavistina 8 mg 100’s tablet",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6285147001903",
    "gtin": "06285147001903"
  },
  {
    "itemNo": "A10201",
    "itemDescription": "LEVAR 5MG F/C TABLET 30 TABLETS_PVT",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870000063",
    "gtin": "06251870000063"
  },
  {
    "itemNo": "A10088",
    "itemDescription": "Lotense 10 mg 30 Cap",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147002245"
  },
  {
    "itemNo": "A10081",
    "itemDescription": "Lotense 5mg Cap.30's",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147002238"
  },
  {
    "itemNo": "A10068",
    "itemDescription": "Mirazol 500 mg 20 tabs",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147014866"
  },
  {
    "itemNo": "A10311",
    "itemDescription": "OLEXA 5MG OD TABLET-30 TABLET PRODUCT_FOC",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "7252876000131",
    "gtin": "06251870000131"
  },
  {
    "itemNo": "A10310",
    "itemDescription": "OLEXA 5MG OD TABLET-30 TABLET PRODUCT_PVT",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "7252876000131",
    "gtin": "06251870000131"
  },
  {
    "itemNo": "A10069",
    "itemDescription": "Omiz 20mg Cap 14s",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147002986"
  },
  {
    "itemNo": "A10050",
    "itemDescription": "Prima D3 50000 IU Sg Caps 30'S_FOC",
    "itemGroup": "Jamjoom-FOC",
    "pic": "",
    "barcode": "",
    "gtin": "06285128015677"
  },
  {
    "itemNo": "A10049",
    "itemDescription": "Prima D3 50000 IU Sg Caps 30'S_PVT",
    "itemGroup": "Jamjoom-Pvt",
    "pic": "",
    "barcode": "",
    "gtin": "06285128015677"
  },
  {
    "itemNo": "A10082",
    "itemDescription": "QUINOX TABS 500 MG 10'S",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6285147003594",
    "gtin": "06285147003594"
  },
  {
    "itemNo": "A10084",
    "itemDescription": "Rapidus 50Mg Tab 20s",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147003730"
  },
  {
    "itemNo": "A10035",
    "itemDescription": "SkinTech Nutritive Cream",
    "itemGroup": "Skintech Retail",
    "pic": "",
    "barcode": "8436589271111",
    "gtin": "08436589271111"
  },
  {
    "itemNo": "A10078",
    "itemDescription": "Tabocine 100 mg 10 Caps",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147004577"
  },
  {
    "itemNo": "A10070",
    "itemDescription": "Toprazole 40mg 15 tab's",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147004881"
  },
  {
    "itemNo": "A10071",
    "itemDescription": "Toprazole 40mg 30 tab's",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "",
    "gtin": "06285147004898"
  },
  {
    "itemNo": "A10072",
    "itemDescription": "Vavo Shampoo 100 ml",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6285147005260",
    "gtin": "06285147005260"
  },
  {
    "itemNo": "A10214",
    "itemDescription": "XAVIR 10MG A/E PACK OF 10 F/C TABLET_FOC",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870097087",
    "gtin": "06251870097087"
  },
  {
    "itemNo": "A10213",
    "itemDescription": "XAVIR 10MG A/E PACK OF 10 F/C TABLET_PVT",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870097087",
    "gtin": "06251870097087"
  },
  {
    "itemNo": "A10210",
    "itemDescription": "XAVIR 15MG A/E PACK OF 28 F/C TAB_FOC",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870097100",
    "gtin": "06251870097100"
  },
  {
    "itemNo": "A10209",
    "itemDescription": "XAVIR 15MG A/E PACK OF 28 F/C TAB_PVT",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870097100",
    "gtin": "06251870097100"
  },
  {
    "itemNo": "A10218",
    "itemDescription": "XAVIR 20MG A/E PACK OF 28 F/C TABLET_FOC",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870097094",
    "gtin": "06251870097094"
  },
  {
    "itemNo": "A10217",
    "itemDescription": "XAVIR 20MG A/E PACK OF 28 F/C TABLET_PVT",
    "itemGroup": "Al-Taqaddom Pharmaceutical Industries",
    "pic": "",
    "barcode": "6251870097094",
    "gtin": "06251870097094"
  },
  {
    "itemNo": "A10037",
    "itemDescription": "XL Hair",
    "itemGroup": "Skintech",
    "pic": "",
    "barcode": "8436589270312",
    "gtin": "08436589270312"
  },
  {
    "itemNo": "A10077",
    "itemDescription": "ZETRON CAPSULES 6'S",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6285147005796",
    "gtin": "06285147005796"
  },
  {
    "itemNo": "A10083",
    "itemDescription": "ZOLIX 5MG TABLET 20's",
    "itemGroup": "Tabuk Pharmaceutical",
    "pic": "",
    "barcode": "6285147005932",
    "gtin": "06285147005932"
  }
];
